import { apiCall } from "../service/api-service";

export const createAccountApi = async (data) => {
  return apiCall("POST", "account", data);
};

export const getAccountsListApi = async (params) => {
  return apiCall("GET", `account${params}`);
};

export const bulkDeleteAccountsApi = async (ids) => {
  const data = Array.isArray(ids) ? { ids } : ids;
  return apiCall("DELETE", "account/bulk_delete", data);
};
export const getAccountViewApi = async (id) => {
  return apiCall("GET", `account/view/${id}`);
};

export const getAccountEditApi = async (id) => {
  return apiCall("GET", `account/edit/${id}`);
};

export const updateAccountApi = async (id, data) => {
  return apiCall("PUT", `account/${id}`, data);
};

export const getAccountContactsApi = async (id, params) => {
  return apiCall("GET", `account/get_contacts/${id}${params}`);
};

export const getAccountQuotationsApi = async (id, params) => {
  return apiCall("GET", `account/get_quotations/${id}${params}`);
};

export const getAccountInvoicesApi = async (id, params) => {
  return apiCall("GET", `account/get_invoices/${id}${params}`);
};

export const getAccountPaymentsApi = async (id, params) => {
  return apiCall("GET", `account/get_payment_history/${id}${params}`);
};

export const getAccountTransactionsApi = async (id, params) => {
  return apiCall("GET", `account/get_transaction_history/${id}${params}`);
};

export const getAccountNotesApi = async (id, params) => {
  return apiCall("GET", `account/get_notes/${id}${params}`);
};

export const saveAccountNoteApi = async (id, data) => {
  return apiCall("POST", `account/add_note/${id}`, data);
};

export const getAccountAttachmentsApi = async (id, params) => {
  return apiCall("GET", `account/get_attachments/${id}${params}`);
};

export const saveAccountAttachmentApi = async (id, data) => {
  return apiCall("POST", `account/add_attachment/${id}`, data);
};

export const getAccountMailTemplateApi = async (id) => {
  return apiCall("GET", `account/mail_template/${id}`);
};

export const sendAccountMailApi = async (id, data) => {
  return apiCall("POST", `account/send_mail/${id}`, data);
};
export const updateAccountStatusApi = async (id, status) => {
  return apiCall("PUT", `account/update_status/${id}`, { status });
};

export const getOutstandingReportApi = async (id) => {
  return apiCall("GET", `account/outstanding_report/${id}`);
};

export const sendOutstandingReportNowApi = async (id, data) => {
  return apiCall("POST", `account/outstanding_report/${id}/send`, data);
};

export const getAllOutstandingReportSchedulesApi = async (params = "") => {
  return apiCall("GET", `account/outstanding_report_schedules${params}`);
};

export const getOutstandingReportScheduleApi = async (id) => {
  return apiCall("GET", `account/outstanding_report/${id}/schedule`);
};

export const saveOutstandingReportScheduleApi = async (id, data) => {
  return apiCall("POST", `account/outstanding_report/${id}/schedule`, data);
};

export const deleteOutstandingReportScheduleApi = async (id) => {
  return apiCall("DELETE", `account/outstanding_report/${id}/schedule`);
};

export const getAccountDiscussionApi = async (id, params) => {
  return apiCall("GET", `account/get_discussion/${id}${params}`);
};

export const getAccountMailDetailApi = async (accountId, mailId) => {
  return apiCall("GET", `account/get_discussion/${accountId}/mail/${mailId}`);
};

export const askAccountChatApi = async (payload) => {
  return apiCall("POST", "account/ai_chat", payload);
};

export const getAccountAiProvidersApi = async () => {
  return apiCall("GET", "account/ai_providers");
};

export const getAccountAiSummaryApi = async (id, payload = {}) => {
  return apiCall("POST", `account/ai_summary/${id}`, payload);
};
